import * as React from 'react';
import { Button, Dropdown, Popup, Icon } from 'semantic-grab-ui/src';
import _ from 'lodash';
import { CountConditionWidget } from 'components/form/trident-campaigns';
import { getNodePopupContent, getDefaultNodeName } from 'omega-rtc/utils/trident-node-utils';
import { nodeTypes } from 'data/trident-types';
import './FlowDesign.scss';
import { CampaignWidgetProps } from 'types/ts/campaigns';
import { preOrderTraversalFromCurrentNodeToItsChildren, renderDropdownItem, getNodeTypeChildOptions } from './util';

export default class CounterWidget extends React.Component<CampaignWidgetProps> {
  render() {
    const { model, canActivate, currentNodeKey, parentKeyList } = this.props;
    const buttonStyleCounter = {
      height: 60,
      width: 150,
      backgroundColor: '#e7fefb',
      borderTopLeftRadius: '30%',
      borderBottomRightRadius: '30%',
      border: '1px solid #83e5de',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    const buttonStyleCounterClicked = {
      height: 60,
      width: 150,
      backgroundColor: '#89e8de',
      borderTopLeftRadius: '30%',
      borderBottomRightRadius: '30%',
      border: '1px solid #22c6c5',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    };
    const addButtonSize = {
      fontSize: '1.5em',
      marginTop: '20px',
      color: '#3498DB',
    };
    const noOfChildren = _.get(model.nodes[currentNodeKey], 'children', []).length;
    const renderAddButton = noOfChildren === 0;

    // check wheather flow is completed or not, it will help to render add button with set of options after flow completed.
    const flowCompleted = preOrderTraversalFromCurrentNodeToItsChildren(model, currentNodeKey, true);
    const addButtonAfterFlow = noOfChildren !== 0 && flowCompleted;
    // preparing ancestor list of current clicked node to send it into node preview display.
    const ancestorList = _.concat(parentKeyList, currentNodeKey);
    const parentKey = parentKeyList[parentKeyList.length - 1];
    const defaultName = getDefaultNodeName(currentNodeKey, nodeTypes.count, _.get(model, 'nodesOccMap'));
    const childOptions = getNodeTypeChildOptions(model.targetUserType,nodeTypes.count);

    return (
      <div className={_.get(this.props.model.nodes[parentKey], 'children', []).length > 1 ? 'entry' : 'entry sole'}>
        <span className="wrapDesign">
          <Popup
            trigger={
              <Button style={this.props.clickedNode === this.props.currentNodeKey ? buttonStyleCounterClicked : buttonStyleCounter} onClick={() => this.props.handleNodePreview(ancestorList, currentNodeKey)}>
                {_.get(model.nodes[currentNodeKey], 'name', defaultName) || defaultName}
              </Button>
            }
            content={getNodePopupContent(model, 'name', currentNodeKey, defaultName)}
          />
          {(renderAddButton || addButtonAfterFlow) &&
            <Dropdown icon="plus square" floating basic className="icon" style={addButtonSize}>
              <Dropdown.Menu>
                {childOptions.map(option =>
                  renderDropdownItem(`Add ${option}`, () => this.props.handleAddNode(option, currentNodeKey, ancestorList))
                )}
              </Dropdown.Menu>
            </Dropdown>
          }
        </span>
        {_.get(model.nodes[currentNodeKey], 'children', []).length > 0 &&
          <div className={renderAddButton || addButtonAfterFlow ? 'dropdownButton' : 'noDropdownButton'}>
            {_.get(model.nodes[currentNodeKey], 'children', []).map((childKey, index) => {
              return (
                <CountConditionWidget
                  key={`${index}${_.get(model.nodes[childKey], 'type')}`}
                  onModelChange={this.props.onModelChange}
                  model={model}
                  currentNodeKey={childKey}
                  canActivate={canActivate}
                  handleAddNode={this.props.handleAddNode}
                  handleNodePreview={this.props.handleNodePreview}
                  parentKeyList={ancestorList}
                  clickedNode={this.props.clickedNode}
                />
              );
            })}
          </div>
        }
      </div>
    );
  }
}
